/** A navigation hint, never identity or authorization. No external redirects. */
export function loginDestination(from?: { pathname?: string; search?: string } | null): string {
  const path = `${from?.pathname ?? '/app'}${from?.search ?? ''}`;
  if (!path.startsWith('/') || path.startsWith('//') || /[\\\u0000-\u0020]/.test(path)) return '/app';
  try {
    const base = 'https://portal.invalid';
    const url = new URL(path, base);
    if (url.origin !== base || ['/login', '/auth'].includes(url.pathname)) return '/app';
    return url.pathname + url.search;
  } catch {
    return '/app';
  }
}

export function hasAuthLinkError(hash: string): boolean {
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  return params.has('error') || params.has('error_code');
}
